import { FormattedMessage } from 'react-intl';
import { PoolButton, PoolModal, PoolModalActions, PoolModalContent, PoolModalTitle } from '@synergy/components-next';
import { ThemeWrapper } from '@synergy/theme-next';
import { useParams } from 'react-router-dom';
import { useState } from 'react';

import { BonusSettlementSearchCustomer } from '../../models/bonus-settlement-detail';
import { PoolCustomerBonusSettlementAutocompleteList } from '../../../../common/autocomplete-list/bonus-settlement-supplier-detail-customer-autocomplete-list/pool-bonus-settlement-supplier-detail-customer-autocomplete-list';
import { addCustomer } from '../store/bonus-settlements-detail-actions';
import { useAppDispatch } from '../../../../store/store';

interface BonusSettlementSupplierDetailAddCustomerModalProps {
    open: boolean;
    readOnly: boolean;
    onClose: () => void;
}

export const BonusSettlementSupplierDetailAddCustomerModal = (
    props: BonusSettlementSupplierDetailAddCustomerModalProps
) => {
    const { open, readOnly, onClose } = props;
    const dispatch = useAppDispatch();
    const { id: supplierBonusSettlementId } = useParams<{ id: string }>();
    const [customer, setCustomer] = useState<BonusSettlementSearchCustomer | null>(null);

    const handleSave = () => {
        if (supplierBonusSettlementId && customer) {
            dispatch(
                addCustomer({
                    supplierBonusSettlementId: +supplierBonusSettlementId,
                    customerId: customer.id,
                })
            );
            onClose();
        }
    };

    const handleClose = () => {
        setCustomer(null);
        onClose();
    };

    return (
        <ThemeWrapper>
            <PoolModal open={open} onClose={handleClose}>
                <PoolModalTitle>
                    <FormattedMessage id="app.bonusSettlements.supplierDetail.addCustomer" />
                </PoolModalTitle>
                <PoolModalContent>
                    {supplierBonusSettlementId && (
                        <PoolCustomerBonusSettlementAutocompleteList
                            onSelected={setCustomer}
                            label={<FormattedMessage id="app.bonusSettlements.supplierDetail.addCustomer" />}
                            required={true}
                            supplierBonusSettlementId={+supplierBonusSettlementId}
                        />
                    )}
                </PoolModalContent>
                <PoolModalActions>
                    <PoolButton variant="outlined" onClick={() => onClose()}>
                        <FormattedMessage id="app.common.close" />
                    </PoolButton>
                    <PoolButton onClick={handleSave} disabled={readOnly || customer === null}>
                        <FormattedMessage id="app.common.save" />
                    </PoolButton>
                </PoolModalActions>
            </PoolModal>
        </ThemeWrapper>
    );
};
